<template>
  <section>
    <!--工具条（按钮权限由后台配置，如"查询" Func=onSearch）-->
    <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>

    <!--筛选区：姓名 / 身份证号 / 时间范围-->
    <el-form :inline="true" class="filter-form" @submit.native.prevent>
      <el-form-item label="姓名">
        <el-input v-model="filters.userName" placeholder="用户姓名" clearable></el-input>
      </el-form-item>
      <el-form-item label="身份证号">
        <el-input v-model="filters.idCardNo" placeholder="身份证号" clearable></el-input>
      </el-form-item>
      <el-form-item label="类别">
        <el-select v-model="filters.type" placeholder="全部" clearable style="width: 130px">
          <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="提问时间">
        <el-date-picker
          v-model="timeRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          clearable>
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSearch">查询</el-button>
        <el-button @click="onReset">重置</el-button>
      </el-form-item>
    </el-form>

    <!--分组列表-->
    <el-table :data="lists" v-loading="listLoading" style="width: 100%" ref="table" class="custom-tbl">
      <el-table-column prop="UserName" label="姓名" width="120" sortable></el-table-column>
      <el-table-column prop="IdCardNo" label="身份证号" width="200"></el-table-column>
      <el-table-column prop="GroupName" label="分组名称" min-width="220" show-overflow-tooltip></el-table-column>
      <el-table-column prop="Type" label="类别" width="120" :formatter="formatType"></el-table-column>
      <el-table-column prop="MessageCount" label="问答数" width="100" sortable></el-table-column>
      <el-table-column prop="LastChatTime" label="最后提问时间" :formatter="formatLastChatTime" width="180" sortable>
      </el-table-column>
      <el-table-column label="操作" width="120" fixed="right">
        <template slot-scope="scope">
          <el-button type="primary" size="small" @click="handleViewDetail(scope.row)">查看明细</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!--分页-->
    <el-col :span="24" class="toolbar">
      <el-pagination layout="prev, pager, next, total" @current-change="handleCurrentChange" :page-size="pagesize"
        :total="total" style="float: right">
      </el-pagination>
    </el-col>

    <!--问答明细抽屉-->
    <el-drawer :title="detailTitle" :visible.sync="detailDrawerVisible" size="60%" :destroy-on-close="true">
      <div class="qa-list" v-loading="detailLoading">
        <el-empty v-if="!detailLoading && records.length === 0" description="暂无问答记录"></el-empty>
        <div v-for="item in records" :key="item.Id" class="qa-item">
          <div class="qa-q">
            <span class="qa-tag qa-tag-q">问</span>
            <span class="qa-q-text">{{ item.Question }}</span>
          </div>
          <div class="qa-meta">
            {{ formatTime(item.CreateTime) }}
            <el-tag v-if="!item.IsSuccess" type="warning" size="mini" disable-transitions>回答中断</el-tag>
          </div>
          <div class="qa-a">
            <span class="qa-tag qa-tag-a">答</span>
            <div class="qa-a-body md-body" v-html="renderMd(item.Answer)"></div>
          </div>
        </div>
      </div>
    </el-drawer>
  </section>
</template>

<script>
import util from "../../../util/date";
import { renderMarkdown } from "../../../util/markdown";
import { getAIChatGroupPage, getAIChatRecordList } from "../../api/api";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";

export default {
  components: { Toolbar },
  data() {
    return {
      buttonList: [],
      //类别（1=法律问题咨询 2=事实界定分析 3=举证质证指引 4=诉讼策略生成）
      typeOptions: [
        { value: 1, label: "法律问题咨询" },
        { value: 2, label: "事实界定分析" },
        { value: 3, label: "举证质证指引" },
        { value: 4, label: "诉讼策略生成" },
      ],
      filters: {
        userName: "",
        idCardNo: "",
        type: null,
      },
      timeRange: null,
      lists: [],
      total: 0,
      page: 1,
      pagesize: 20,
      listLoading: false,
      //明细抽屉
      detailDrawerVisible: false,
      detailLoading: false,
      detailTitle: "问答明细",
      records: [],
    };
  },
  methods: {
    callFunction(item) {
      this[item.Func].apply(this, item);
    },
    onSearch() {
      this.page = 1;
      this.getList();
    },
    onReset() {
      this.filters = { userName: "", idCardNo: "", type: null };
      this.timeRange = null;
      this.page = 1;
      this.getList();
    },
    //类别数字转名称
    formatType: function (row) {
      let item = this.typeOptions.find((t) => t.value === row.Type);
      return item ? item.label : "未知";
    },
    formatLastChatTime: function (row, column) {
      return !row.LastChatTime || row.LastChatTime == ""
        ? ""
        : util.formatDate.format(new Date(row.LastChatTime), "yyyy-MM-dd hh:mm:ss");
    },
    formatTime(time) {
      return !time ? "" : util.formatDate.format(new Date(time), "yyyy-MM-dd hh:mm:ss");
    },
    renderMd(text) {
      return renderMarkdown(text);
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    //获取分组分页
    getList() {
      let para = {
        page: this.page,
        size: this.pagesize,
        userName: this.filters.userName || "",
        idCardNo: this.filters.idCardNo || "",
        beginTime: this.timeRange && this.timeRange[0] ? this.timeRange[0] + " 00:00:00" : null,
        endTime: this.timeRange && this.timeRange[1] ? this.timeRange[1] + " 23:59:59" : null,
        type: this.filters.type || 0,
      };
      this.listLoading = true;
      getAIChatGroupPage(para).then((res) => {
        if (res.data.response != null) {
          var result = res.data.response;
          this.total = result.dataCount;
          this.pagesize = result.PageSize;
          this.lists = result.data;
        }
        this.listLoading = false;
      }).catch(() => {
        this.listLoading = false;
      });
    },
    //查看问答明细
    handleViewDetail(row) {
      this.detailDrawerVisible = true;
      this.detailLoading = true;
      this.records = [];
      getAIChatRecordList({ groupId: row.GroupGuid }).then((res) => {
        this.detailLoading = false;
        if (res.data.success && res.data.response) {
          this.detailTitle = "问答明细 - " + res.data.response.GroupName;
          this.records = res.data.response.Records || [];
        } else {
          this.detailTitle = "问答明细";
          this.$message({ message: res.data.msg || "获取明细失败", type: "error" });
        }
      }).catch(() => {
        this.detailLoading = false;
      });
    },
  },
  mounted() {
    this.getList();
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style scoped>
.filter-form {
  margin-top: 10px;
}

.qa-list {
  padding: 0 24px 24px;
}

.qa-item {
  border: 1px solid #ebeef5;
  border-radius: 8px;
  padding: 14px 18px;
  margin-bottom: 16px;
  background: #fafbfc;
}

.qa-q {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.qa-tag {
  flex-shrink: 0;
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
  color: #fff;
  line-height: 20px;
}

.qa-tag-q {
  background: #1668ff;
}

.qa-tag-a {
  background: #67c23a;
}

.qa-q-text {
  font-size: 15px;
  color: #303133;
  font-weight: 600;
  line-height: 24px;
  white-space: pre-wrap;
  word-break: break-word;
}

.qa-meta {
  margin: 6px 0 10px 40px;
  font-size: 12px;
  color: #909399;
}

.qa-meta .el-tag {
  margin-left: 8px;
}

.qa-a {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.qa-a-body {
  flex: 1;
  font-size: 14px;
  color: #303133;
  line-height: 1.8;
  background: #fff;
  border-radius: 6px;
  padding: 10px 14px;
  word-break: break-word;
}

/* markdown 排版 */
.md-body /deep/ p {
  margin: 0 0 10px;
}

.md-body /deep/ p:last-child {
  margin-bottom: 0;
}

.md-body /deep/ h1,
.md-body /deep/ h2,
.md-body /deep/ h3,
.md-body /deep/ h4 {
  margin: 14px 0 8px;
  line-height: 1.4;
}

.md-body /deep/ h1 {
  font-size: 20px;
}

.md-body /deep/ h2 {
  font-size: 18px;
}

.md-body /deep/ h3 {
  font-size: 16px;
}

.md-body /deep/ ul,
.md-body /deep/ ol {
  margin: 6px 0 10px;
  padding-left: 24px;
}

.md-body /deep/ li {
  margin: 4px 0;
}

.md-body /deep/ table {
  border-collapse: collapse;
  margin: 8px 0;
}

.md-body /deep/ th,
.md-body /deep/ td {
  border: 1px solid #dcdfe6;
  padding: 6px 12px;
}

.md-body /deep/ code {
  background: #f0f5ff;
  border-radius: 4px;
  padding: 1px 5px;
}

.md-body /deep/ blockquote {
  margin: 8px 0;
  padding: 4px 14px;
  border-left: 4px solid #1668ff;
  background: #f7fbff;
}
</style>
